import { ReduxNullableArrayState } from '../types'

export const nullableStateToArray = <E>(state: ReduxNullableArrayState<E>): E[] => [...(state || ([] as E[]))]
